// Finder页面相关埋点事件ID

export const FinderTrackEvents = {
  // Find by Name 相关埋点
  FinderByNameEmailButtonClick: "FinderByNameEmailButtonClick", // Find by Name: 【Find Email】按钮的点击
  FinderByNameResultsShow: "FinderByNameResultsShow", // Find by Name: 有结果展示次数
  FinderByNameEmailDeliveryShow: "FinderByNameEmailDeliveryShow", // Find by Name: 邮箱查到和未查到的次数
  FinderByNameContinueButtonClick: "FinderByNameContinueButtonClick", // Find by Name: 【Continue to find】按钮点击次数

  // 付费引导相关埋点
  FinderUpgradeButtonClick: "FinderUpgradeButtonClick", // 付费引导窗【Upgrade to Unlimited】按钮点击次数
  FinderShowUpgradePopover: "FinderShowUpgradePopover", // Finder页展示付费引导弹窗
  FinderUpgradeCornerButtonClick: "FinderUpgradeCornerButtonClick", // 付费引导窗"右上角叉号"点击次数
  
  // Reward相关埋点
  FinderRewardInstallButtonClick: "FinderRewardInstallButtonClick", // Reward引导窗【Install to earn 50 credits】按钮点击次数
  FinderRewardTasksButtonClick: "FinderRewardTasksButtonClick", // Reward引导窗"Complete more tasks to earn credits"点击次数
  FinderRewardCornerButtonClick: "FinderRewardCornerButtonClick", // Reward引导窗"右上角叉号"点击次数
  
  // 付费任务相关埋点
  FinderPayTasksButtonClick: "FinderPayTasksButtonClick", // 付费引导窗"Complete tasks to earn free credits"点击次数
  FinderPayCornerButtonClick: "FinderPayCornerButtonClick", // 付费引导窗"右上角叉号"点击次数

  // Find by Decision Maker 相关埋点
  FinderByDecisionMakerContactButtonClick: "FinderByDecisionMakerContactButtonClick", // Find by Decision Maker: 【Find Contact】按钮的点击
  FinderByDecisionMakerInstallGuideClick: "FinderByDecisionMakerInstallGuideClick", // Find by Decision Maker: 点击安装插件引导次数
  FinderByDecisionMakerStartButtonClick: "FinderByDecisionMakerStartButtonClick", // Find by Decision Maker: 弹窗【Let's Start】按钮点击次数
  FinderByDecisionMakerCornerButtonClick: "FinderByDecisionMakerCornerButtonClick", // Find by Decision Maker: 弹窗"右上角叉号"点击次数
  FinderByDecisionMakerResultsShow: "FinderByDecisionMakerResultsShow", // Find by Decision Maker: 结果展示次数
  FinderByDecisionMakerEmptyResultsShow: "FinderByDecisionMakerEmptyResultsShow", // Find by Decision Maker: 缺省页展示次数
  FinderByDecisionMakerLinkedinCompanyFound: "FinderByDecisionMakerLinkedinCompanyFound", // Find by Decision Maker: 查询到领英的企业
  FinderByDecisionMakerUpgradeButtonClick: "FinderByDecisionMakerUpgradeButtonClick", // Find by Decision Maker: 弹窗【Upgrade 】按钮点击次数
  FinderByDecisionMakerCareerSelect: "FinderByDecisionMakerCareerSelect", // Find by Decision Maker: 弹窗【职业选择】下拉框 的点击
  FinderByDecisionMakerUpgradeBtnShow: "FinderByDecisionMakerUpgradeBtnShow", // Find by Decision Maker: 弹窗【升级】按钮展示

  // Find from LinkedIn 相关埋点
  FinderFromLinkedInEmailButtonClick: "FinderFromLinkedInEmailButtonClick", // Find from LinkedIn: 【Find Email】按钮点击次数
  FinderFromLinkedInInstallGuideClick: "FinderFromLinkedInInstallGuideClick", // Find from LinkedIn: 点击安装插件引导次数
  FinderFromLinkedInEmailDeliveryShow: "FinderFromLinkedInEmailDeliveryShow", // Find from LinkedIn: 邮箱查到和未查到的次数
  FinderFromLinkedInContinueButtonClick: "FinderFromLinkedInContinueButtonClick", // Find from LinkedIn: 【Continue to find】按钮点击次数
  FinderFromLinkedInResultsShow: "FinderFromLinkedInResultsShow", // Find from LinkedIn: 有结果展示次数

  // 其他操作埋点
  FinderEmailCopyOperation: "FinderEmailCopyOperation", // "复制邮箱"操作次数
  FinderPhoneCopyOperation: "FinderPhoneCopyOperation", // "复制电话"操作次数
  FinderContactButtonClick: "FinderContactButtonClick", // Find by Decision Maker: 【Find Contact】按钮点击次数

  // Chrome Extension Modal 相关埋点
  FinderEmailViewEmailButtonClick: "FinderEmailViewEmailButtonClick", // Finder页【View Email】按钮点击次数
  FinderChromeExtensionGuideButtonClick: "FinderChromeExtensionGuideButtonClick", // Finder页【Chrome Extension Guide】按钮点击次数
  FinderEmailAddToChromeButtonClick: "FinderEmailAddToChromeButtonClick", // Finder页【Add to Chrome】按钮点击次数
};

export default FinderTrackEvents; 